export default "__VITE_ASSET__19eb2348__"